export default __webpack_public_path__ + "static/media/streaming.11cab8d2.png";